"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceChinese = exports.initSearchResultTableTitle = exports.initSearchTitlesTextAndCodeMap = exports.initPageRoutes = void 0;
const tableUtils_1 = require("@containers/common/utils/tableUtils");
exports.initPageRoutes = {
    pageButtonGroup: {
        isDisplay: true,
        isExpand: true
    },
    searchForm: {
        isDisplay: false,
        isExpand: true
    },
    addForm: {
        isDisplay: false,
        isExpand: true
    },
    searchResult: {
        isDisplay: false
    }
};
exports.initSearchTitlesTextAndCodeMap = [
    { titleText: '名', titleCode: 'firstName' },
    { titleText: '姓', titleCode: 'lastName' },
    { titleText: '年齡', titleCode: 'age' },
    { titleText: '性別', titleCode: 'gender' },
    { titleText: '生日', titleCode: 'birthDate' }
];
exports.initSearchResultTableTitle = (0, tableUtils_1.getInitTableTitleStatus)(exports.initSearchTitlesTextAndCodeMap, 'discardFunctionalColumn');
const chinese = /[\u4E00-\u9FA5]/g;
const replaceChinese = (str) => {
    const result = str.replace(chinese, '');
    return result;
};
exports.replaceChinese = replaceChinese;
